/** @format */

export const FONT = {
  //font sizes
  F_XS: '0.75rem', // 12px
  F_SM: '0.875rem', // 14px
  F_BASE: '1rem', // 16px
  F_LG: '1.125rem', // 18px
  F_XL: '1.25rem', // 20px
  F_2XL: '1.5rem', // 24px
  F_3XL: '1.875rem', // 30px
  F_4XL: '2.25rem', // 36px
  F_5XL: '3rem', // 48px
  F_6XL: '3.75rem', // 60px
  F_7XL: '4.5rem', // 72px
  F_8XL: '6rem', // 96px
  F_9XL: '8rem', // 128px

  //font weight
  FW_100: '100',
  FW_200: '200',
  FW_300: '300',
  FW_400: '400',
  FW_500: '500',
  FW_600: '600',
  FW_700: '700',
  FW_800: '800',
  FW_900: '900',
}
